import React, { Fragment, useContext } from 'react';
import PropTypes from 'prop-types';
import { BreakpointTrackerContext } from '@jutro/layout';
import ImageComponent from '../../../../../../../common/modules-react/gw-components-platform-react/ImageComponent/ImageComponent';
import styles from './EntryPageTemplate.module.scss';

function EntryPageTemplate(props) {
    const {
        applicationName, applicationLogo, contentToRender, applicationMobileLogo, applicationLogo2
    } = props;
    const breakpoint = useContext(BreakpointTrackerContext);

    return (
        <Fragment>
            <div id="entryPageTemplate" className={styles.entryPageTemplate}>
                <div id="entryPageTemplateHeader" className={styles.entryPageTemplateHeader}>
                    <div className={styles.entryPageTemplateHeaderContent}>
                        <div id="entryPageTemplateLogo" className={styles.entryPageTemplateLogo}>
                            { breakpoint === 'desktop' && <ImageComponent src={applicationLogo} title={applicationName} /> }
                            { (breakpoint === 'phone' || breakpoint === 'tablet') && <ImageComponent src={applicationMobileLogo} title={applicationName} />}
                        </div>
                        <h2
                            id="entryPageTemplateApplicationName"
                            className={styles.entryPageTemplateApplicationName}
                        >
                            {applicationName}
                        </h2>
                    </div>
                    <div className={styles.applicationLogoOntario}>
                        <ImageComponent src={applicationLogo2} />
                    </div>
                </div>
                <div id="entryPageTemplateContent" className={styles.entryPageTemplateContent}>
                    <div
                        id="entryPageContentContainer"
                        className={styles.entryPageContentContainer}
                    >
                        {contentToRender}
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

EntryPageTemplate.propTypes = {
    applicationName: PropTypes.string.isRequired,
    applicationLogo: PropTypes.string.isRequired,
    contentToRender: PropTypes.shape({}).isRequired,
    applicationMobileLogo: PropTypes.string.isRequired,
    applicationLogo2: PropTypes.string.isRequired
};

export default EntryPageTemplate;
